export const filterAndSplitJsonChoice = (text) => {
    try {
        text = text.replace(/```json/g, "").replace(/```/g, "");
     
        let array = JSON.parse(text);
        if (!Array.isArray(array)) {
            throw new Error("Input is not a JSON array");
        }

        // Filter out questions that have answers with empty or non-existent text fields
        array = array.filter((questionObj) => {
            return questionObj.answers?.every((answerObj) => {
                return (
                    typeof answerObj.text === "string" &&
                    answerObj.text.trim() !== ""
                );
            });
        });

        array.forEach((questionObj, qIndex) => {
            questionObj.id = `Q${qIndex + 1}`;
            questionObj.isSelected = false;

            questionObj.answers.forEach((answerObj, aIndex) => {
                answerObj.id = `A${qIndex + 1}-${aIndex + 1}`;
                answerObj.isSelected = false;
                answerObj.noneOfAbove = false;
                answerObj.allOfAbove = false;
            });
        });

        function shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
        }

        // Iterate through each question and shuffle the answers
        array.forEach((question) => {
            shuffleArray(question.answers); // Shuffle the answers randomly

            // Find the correct answer and ensure it remains correct
            const correctAnswer = question.answers.find(
                (answer) => answer.correct
            );
            if (correctAnswer) {
                correctAnswer.correct = true; // Ensure correct answer remains true
            }

            // Set all other answers to be incorrect
            question.answers.forEach((answer) => {
                if (answer !== correctAnswer) {
                    answer.correct = false;
                }
            });
        });

        return array;
    } catch (error) {
        console.error("Error processing JSON:", error);
        return "error";
    }
};

export const filterAndSplitJsonWritten = (text) => {
    try {
        text = text.replace(/```json/g, "").replace(/```/g, "");
        let array = JSON?.parse(text);
        const dataWithIdsAndAnswers = array?.map((item, index) => ({
            id: index + 1,
            question: item.question,
            answer: item.answer,
            userAnswer: null,
        }));
        return dataWithIdsAndAnswers;
    } catch (error) {
        return "error";
    }
};

export const filterFlashcardJson = (array) => {
    try {
        array = array.replace(/```json/g, "").replace(/```/g, "");
        let data = JSON.parse(array);
        let newArray = data
            .filter((card) => "front" in card && "back" in card)
            .map((card, index) => ({
                front: card.front,
                back: card.back,
                correct: false,
                incorrect: false,
                id: index,
            }));
        return newArray;
    } catch (error) {
        return "error";
    }
};
